












import { mapActions } from 'vuex';
import { apiUrl } from '@/env';

export default {
  name: 'Embedded',
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      src: '',
    };
  },
  created() {
    window.addEventListener('message', e => this.updateURL(e.data), false);
    this.setPageTitle({ title: this.pageTitle, visible: false });
  },
  mounted() {
    const originalLocation = window.location.href.replace(window.location.origin, apiUrl);
    this.src = originalLocation;
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
    }),
    updateURL(data) {
      if (data.location && apiUrl) {
        const sanitizedURL = data.location.replace(apiUrl, '');
        this.$router.replace(sanitizedURL);
      }
    },
  },
};
